<template>
  <div class="queried-knowledge-list">
    <a-card title="输入参数匹配到的知识" size="small">
      <div v-if="groupedKnowledge.length > 0">
        <a-list size="small">
          <template v-for="group in groupedKnowledge" :key="group.type">
            <a-list-item>
              <a-typography-title :level="5" style="margin: 0">{{ group.typeName }}</a-typography-title>
            </a-list-item>
            <a-list-item 
              v-for="item in group.items" 
              :key="item.id"
              :class="{ 'selected': selectedKnowledgeId === item.id }"
              style="padding-left: 24px"
            >
              <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                <span 
                  style="cursor: pointer; flex: 1;"
                  @click="handleClick(item.id)"
                >{{ item.title }}</span>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <a-tag color="green" size="small">匹配</a-tag>
                  <a 
                    href="#" 
                    @click.stop="handleOpenKnowledge(item.id)"
                    style="font-size: 12px;"
                  >查看</a>
                </div>
              </div>
            </a-list-item>
          </template>
        </a-list>
        
        <!-- 展示搜索SQL -->
        <a-divider style="margin: 16px 0" />
        <div v-if="debugSQL && Object.keys(debugSQL).length > 0">
          <a-typography-title :level="5" style="margin-bottom: 8px">搜索SQL</a-typography-title>
          <a-collapse v-model:activeKey="activeKeys" size="small">
            <a-collapse-panel 
              v-for="(sqlInfo, typeCode) in debugSQL" 
              :key="typeCode"
              :header="getTypeName(typeCode)"
            >
              <div style="margin-bottom: 8px">
                <strong>COUNT SQL:</strong>
                <pre style="background: #f5f5f5; padding: 8px; border-radius: 4px; overflow-x: auto; font-size: 12px; margin-top: 4px">{{ sqlInfo.count_sql }}</pre>
              </div>
              <div>
                <strong>LIST SQL:</strong>
                <pre style="background: #f5f5f5; padding: 8px; border-radius: 4px; overflow-x: auto; font-size: 12px; margin-top: 4px">{{ sqlInfo.list_sql }}</pre>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
      <div v-else style="color: #999; text-align: center; padding: 16px">
        未找到匹配的知识
      </div>
    </a-card>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';

const TYPE_NAMES = {
  prompt: '提示词',
  dataflow: '数据流',
  pin_info: '针脚信息',
  case: '典型案例',
  principle: '系统原理'
};

export default {
  name: 'QueriedKnowledgeList',
  props: {
    queriedKnowledge: {
      type: Object,
      default: null
    },
    debugSQL: {
      type: Object,
      default: null
    },
    selectedKnowledgeId: {
      type: Number,
      default: null
    }
  },
  emits: ['knowledge-click'],
  setup(props, { emit }) {
    const router = useRouter();
    const activeKeys = ref([]);

    const groupedKnowledge = computed(() => {
      if (!props.queriedKnowledge) {
        return [];
      }

      const groups = {};
      for (const [typeCode, knowledgeList] of Object.entries(props.queriedKnowledge)) {
        if (!Array.isArray(knowledgeList) || knowledgeList.length === 0) {
          continue;
        }

        if (!groups[typeCode]) {
          groups[typeCode] = {
            type: typeCode,
            typeName: TYPE_NAMES[typeCode] || typeCode,
            items: []
          };
        }

        knowledgeList.forEach(k => {
          if (k && k.id) {
            groups[typeCode].items.push({
              ...k,
              type_code: typeCode
            });
          }
        });
      }

      return Object.values(groups);
    });

    const getTypeName = (typeCode) => {
      return TYPE_NAMES[typeCode] || typeCode;
    };

    const handleClick = (knowledgeId) => {
      emit('knowledge-click', knowledgeId);
    };

    const handleOpenKnowledge = (knowledgeId) => {
      const routeData = router.resolve({ name: 'knowledge-edit', params: { id: knowledgeId } });
      window.open(routeData.href, '_blank');
    };

    return {
      groupedKnowledge,
      activeKeys,
      getTypeName,
      handleClick,
      handleOpenKnowledge
    };
  }
};
</script>

<style scoped>
.queried-knowledge-list {
  margin-bottom: 16px;
}

.selected {
  background-color: #e6f7ff;
}

pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>

